// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__sOxtB","footer":"ModalError_footer__3uHnw"};